const region = ""

const prod = {
	appSettingsData: {
		BuyerCognitoGroup: 'wl-pd-procurement-portal-buyers',
		SupplierCognitoGroup: 'wl-pd-procurement-portal-suppliers',
		federatedIDPProvider: 'wl-pd-procurement-portal-idp'
	},
	amplify_config: {
		Auth: {
			mandatorySignIn: true,
			region: region,
			userPoolId: "us-east-1_W6LgPX3ub",
			userPoolWebClientId: "7uvgo0aajf73sh9qh6ftdtobg0",
		},
		oauth: {
			domain: "wl-procurement-portal.auth.us-east-1.amazoncognito.com",
			scope: [],
			redirectSignIn: "https://wl-procurement-portal.com/login",
			redirectSignOut: "https://wl-procurement-portal.com/login",
			// redirectSignIn: "http://localhost:3000/login",
			// redirectSignOut: "http://localhost:3000/login",
			responseType: "code",
			clientId: "m9brispk49a5tqs4bc73tb78o",
		},
		API: {
			endpoints: [
				{
					name: "print",
					endpoint: "https://api.wl-procurement-portal.com/print",
					region: region
				}
			]
		},
	}
};



export default prod;